import filter from 'lodash/filter';

import {IntermediatePart} from "../../parts/intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import Config from "../../../../../config";
import { Vanity } from "../../parts/vanity";

export default class VanityFaucet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_faucet';
    this.partName = 'Faucet';
    this.translateId = "visualizer.bathroom.vanity.vanity_faucet";
    this.homePageTitle = 'Faucets';
    this.useMatchesFailedNavigation = true;
    this.visible = [Vanity.Types.Custom];
    if (Config.isDevMode()) {
      this.canBeDisabled = true;
    }
  }

  load(dbFeature) {
    const vanityFaucetFeature = this.load_(dbFeature, new VanityFaucet());
    if (vanityFaucetFeature) {
      VanityFaucet.setAdditionalMetaData(vanityFaucetFeature);
    }
  }

  static setAdditionalMetaData(vanityFaucetFeature) {
    const compatible = vanityFaucetFeature.metaData["SinkSize"];
    const size = vanityFaucetFeature.metaData["Size"];
    if (compatible && compatible.includes("Outer") && !compatible.includes("Inner")) {
      compatible.push("Inner")
    }
    if (size && !compatible) {
      vanityFaucetFeature.metaData["SinkSize"] = size.includes("21in") ? ["Outer", "Inner"] : [];
    }
  }

  disabledClick() {
    this.getParent().toggleVanityParts(this.disabled);
  }

  getCurrentSinkSize() {
    const sinkParent = this.getParent().sink;
    if (sinkParent && sinkParent.activeFeature) {
      const sinkMeta = sinkParent.activeFeature.metaData["SinkSize"];
      if (sinkMeta) {
        return Array.isArray(sinkMeta) ? sinkMeta[0] : sinkMeta
      } else if (sinkParent.activeFeature.partName.includes("Placeholder")) {
        return "Outer"
      }
    }
    return null
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    const sinkSize = this.getCurrentSinkSize();
    if (sinkSize) {
      return super.navigationSubItemsWithFilterWithInactive('SinkSize', sinkSize, featuresToDisplay)
    }
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  getArrayOfConditions(withSinkSize) {
    const counterTopSize = this.getParent().counterTopSize();
    const conditions = [{
      propName: 'VanitySize',
      propValue: counterTopSize
    }];
    if (withSinkSize) {
      conditions.push({
        propName: 'SinkSize',
        propValue: this.getCurrentSinkSize()
      })
    }
    return conditions;
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions(true))
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  getAvailableFeatures() {
    return filter(this.features, f => f.matchesMetaForCondition('VanitySize', this.getParent().counterTopSize()));
  }

  handleChangeParent(nonCompatibleWith) {
    if (nonCompatibleWith === "sink") {
      this.getParent().getParent().sink.setActiveFeatureByFilter("SinkSize", "Inner")
    } else {
      this.getParent().getParent().pedestalSink.setActiveFeatureByFilter("Size", this.metaData["VanitySize"] ? this.metaData["VanitySize"][0] : null); // "60in", etc.
    }
  }

  setDefault(layout) {
    const filteredFeatures = this.features && this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions(true))) || [];
    let name = null;
    if (this.activeFeature) {
      name = this.activeFeature.partName
    }
    if (!super.tryToSetTheSameFeature(filteredFeatures, name ? name.substring(0, name.length - 2) : null)) {   // remove 2 last letters // "Platte 456AS D"
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Platte 456AS");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndexes.Vanity.Custom.Faucet;
      }
      if(this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Vanity.Custom.Faucet;
      }
    }
  }
}
